import React, {useEffect, useState} from "react";
import productform from "@src/../js/alpine/components/product/productform";
import "./FindInStore.scss";

export const FindInStore = ({ }) => {
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError]: any = useState(null);
    const [sku, setSku] = useState(null); // Manage SKU dynamically
    const [selectedSize, setSelectedSize] = useState(null); // Manage SKU dynamically


    useEffect(() => {
        const handleVariantSwitched = (event) => {
            const variantOption = event.detail.variant;

            const variantSku = variantOption.target.getAttribute("data-variant-sku");
            const variantSize = variantOption.target.getAttribute("value");
            // console.log(variantSku);
            // console.log(variantSize);
            if (variantOption && variantSku) {
                console.log("Variant switched. New SKU:", variantSku, variantSize);
                setSku(variantSku);
                setSelectedSize(variantSize);
                fetchStoreAvailability(variantSize, variantSku);
            }
        };

        // Add event listener for 'variantSwitched'
        window.addEventListener("variantSwitched", handleVariantSwitched);

        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener("variantSwitched", handleVariantSwitched);
        };
    }, []);

    // sku = 'M2404DR308BWN1';
    //https://shopifyleematthewsapp.testarc.com.au/api/2021-10/findinstore?shop=lee-mathews.myshopify.com&sku=M2404DR308BWN1

    const fetchStoreAvailability = async (variantSize, variantSku) => {
        console.log('Fetching store availability', variantSize);

        setLoading(true);
        setError(null);

        if (!variantSize) {
            setError("Please select a size");
            console.log('Invalid Size', variantSize);
            return;
        }

        try {
            // variantSku ='M2404DR308BWN1';
            const response = await fetch(
                `https://shopifyleematthewsapp.testarc.com.au/api/2021-10/findinstore?shop=lee-mathews.myshopify.com&sku=${variantSku}`
            );


            if (!response.ok) {
                throw new Error("Failed to fetch store availability");
            }

            const data = await response.json();
            if (data.success) {
                const availableStores = data.locations.filter(
                    (location) => location.stock_status
                );
                console.log('Available Stores', availableStores);
                setStores(availableStores);

                if (availableStores.length <= 0){
                    setError("No stores found with the selected size.");
                }
            } else {
                setError("No stores found with the selected size.");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="find-in-store">

            {error && (
                <p className="b2 mt-2">
                    {error}
                </p>
            )}

            {loading && <p className="b2 mt-2">Loading...</p>}

            {stores.length > 0 && (
                <div className="mt-4">
                    <p className="b2">Size {selectedSize} is available at the following stores:</p>
                    <ul className="mt-2">
                        {stores.map((store) => (
                            <li key={store.id} className={`findinstore-store`}>
                                <p className={`findinstore-store__title h4`}>{store.store_name}</p>
                                <p className={'b2'}>T: {store.phone}</p>
                                <p className={'b2'}>
                                    {store.address_1}, {store.suburb} {store.state} {store.postcode}
                                </p>
                                {store.pickup_status === "Y" && (
                                    <p className={'b2'}>Available for Click and Collect at checkout</p>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default FindInStore;
